import React from 'react';
import CustomModal from '../../../../../../../components/Modal/CustomModal';
import DeductionPolicyForm from './DeductionPolicyForm';
import DeductionPolicyUpdateApp from '../Functionality/DeductionPolicyUpdateApp';

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTitle: Full Stack Developer
 */
const DeductionPolicyUpdate = ({ show, row, onHide, onSuccess }) => {
    const { t, item, setItem, emptyFields, isValidValue, isValidValueText, handleSubmit } = DeductionPolicyUpdateApp({ show, row, onHide, onSuccess });

    return (
        <CustomModal
            show={show}
            title={t('update_deduction_policy')}
            buttonConfirm='update'
            onHide={onHide}
            onConfirm={handleSubmit}
        >
            <div className={"mt-2"}>
                <DeductionPolicyForm
                    item={item}
                    setItem={setItem}
                    emptyFields={emptyFields}
                    isValidValue={isValidValue}
                    isValidValueText={isValidValueText}
                />
            </div>
        </CustomModal>
    );
};

export default DeductionPolicyUpdate;
